import axios from "axios";
import { PagedResult } from "../interface/iPagedResult";

const API_BASE =
    process.env.REACT_APP_API_URL?.replace(/\/$/, "") ?? "https://localhost:7080";

const PUBLIC_RECIPES_URL = `${API_BASE}/api/publicRecipe`;

export const publicRecipeService = {
    async getAll(): Promise<any[]> {
        const res = await axios.get<any[]>(PUBLIC_RECIPES_URL);
        return res.data;
    },

    async getPaged(args: {
        page: number;
        pageSize: number;
        q?: string;
    }): Promise<PagedResult<any>> {
        const { page, pageSize, q } = args;

        const res = await axios.get<PagedResult<any>>(PUBLIC_RECIPES_URL, {
            params: { page, pageSize, q: q?.trim() || undefined }, // <-- sends q only if non-empty
        });

        return res.data;
    },

    async getById(id: number): Promise<any> {
        const res = await axios.get<any>(`${PUBLIC_RECIPES_URL}/${id}`);
        return res.data;
    },

   
};
